import React from 'react'
import { Link } from "react-router-dom"
import ButtonUI from '../../../widgets/action/ButtonUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import AccountRemarksModalSF from '../account/util/AccountRemarksModalSF'
import './ScoreCard.css'

const ScoreCardUI = ({ context, account, scores, provisionalYear, ranges, onRefreshClick,
  allYrs, onShowAllClick, onShowRecentClick,
  showRng, onShowScoreRanges, onHideScoreRanges,
  updClk, updateRemarksMode, onCancelRemarksClick, objectCode, objectId, selectedRemarks,
  onShowDetails, showDetailsMode, toggleEditable, edit,
  onToggleMcaItr, itr, onToggleClassicStp, stp
}) =>
  <div className='su_sc'>
    {
      !scores &&
      <SpinnerComponentUI />
    }
    {
      scores &&
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Score Card</b></span>
        </span>
      }
      right={
        <span className='g_flex_right g_flex_h'>
          <UpdateProvisionals showDetailsMode={showDetailsMode} onShowDetails={onShowDetails} />
          <Link to='#' onClick={toggleEditable}>Details</Link>
          <SwitchUI label='STP' className='g_m_left_100' checked={stp} onChange={onToggleClassicStp} />
          <SwitchUI label='MCA-ITR' className='g_m_left_100' checked={itr} onChange={onToggleMcaItr} />
        </span>
      }
    />
    }
    {
      scores &&
      <table><thead className='g_sticky'>
        <tr>
          <td>
            {!allYrs && <ButtonUI onClick={onShowAllClick} transparent={true} label='>>>>>>>>' />}
            {allYrs && <ButtonUI onClick={onShowRecentClick} transparent={true} label='<<<<<<<<' />}
          </td>
          {
            scores.map((row, i) =>
              <React.Fragment key={i}>
                {
                  (i == scores.length - 3 || i == scores.length - 2 || i == scores.length - 1) &&
                  <td className='center'>
                    <div className='g_m_left_100 g_m_right_100 '><b className='g_no_wrap'>{row.financialYear}</b></div>
                    {
                      i !== scores.length - 1 && row.financialYear !== provisionalYear &&
                      <span className='g_small'>Audited</span>
                    }
                    {
                      row.financialYear === provisionalYear &&
                      <span className='g_small'>Provisional</span>
                    }
                    {
                      i === scores.length - 1 && row.financialYear !== provisionalYear &&
                      <span className='g_small'>-</span>
                    }
                  </td>
                }
                {
                  (i != scores.length - 3 && i != scores.length - 2 && i != scores.length - 1) && allYrs &&
                  <td className='right g_ultra_muted'>
                    <div className='g_m_left_100'><b className='g_no_wrap'>{row.financialYear}</b></div>
                    {
                      (i !== scores.length - 2 && i !== scores.length - 1) &&
                      <span className='g_small'>Audited</span>
                    }
                  </td>
                }
              </React.Fragment>
            )
          }
          <td className='g_text_center'>
            {!showRng && <ButtonUI onClick={onShowScoreRanges} transparent={true} label='vvvvvvvv' />}
            {showRng && <ButtonUI onClick={onHideScoreRanges} transparent={true} label='^^^^^^^^' />}
          </td>
        </tr>
      </thead><tbody>
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='1' name='companyCreditRating' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='2' name='leadDirectorCreditRating' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='3' name='dscr' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='4' name='loanToValue' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='5' name='revenueToLoanRatio' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='6' name='liabilityToRevenueRatio' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='7' name='netDebtToEbitdaRatio' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='8' name='cashProfitPercent' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='9' name='receivablesToIncomeRatio' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='10' name='dso' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='11' name='chequeBounce' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='12' name='triangulationIncome' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='13' name='triangulationDebt' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='14' name='triangulationExpenses' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='15' name='triangulationCashProfit' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='16' name='noOfLitigations' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='18' name='delinquencies' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='19' name='trackRecordCompany' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='20' name='trackRecordPromoter' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='21' name='references' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='22' name='stateCount' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='23' name='poCounterParty' />
          <RowM scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} id='24' name='ldPaid' />
          <TotalUI scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} updClk={updClk} edit={edit} stp={stp} itr={itr} />
        </tbody></table>
    }

    <AccountRemarksModalSF context={context} account={account}
      updateMode={updateRemarksMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick} objectCode={objectCode} objectId={objectId}
      selectedRemarks={selectedRemarks}
    />

    {/*<div className='g_m_top_200 g_m_bottom_100 g_xlarge'><b>Scorecard with MCA data from Novel Patterns</b></div>*/}

    {/*
      scores &&
      <table><thead className='g_sticky'>
        <tr>
          <td>
            {!allYrs && <ButtonUI onClick={onShowAllClick} transparent={true} label='>>>>>>>>' />}
            {allYrs && <ButtonUI onClick={onShowRecentClick} transparent={true} label='<<<<<<<<' />}
          </td>
          {
            scores.map((row, i) =>
              <React.Fragment key={i}>
                {
                  (i == scores.length - 3 || i == scores.length - 2 || i == scores.length - 1) &&
                  <td className='right'>
                    <div className='g_m_left_100'><b className='g_no_wrap'>{row.financialYear}</b></div>
                    {
                      i !== scores.length - 1 && row.financialYear !== provisionalYear &&
                      <span className='g_small'>Audited</span>
                    }
                    {
                      row.financialYear === provisionalYear &&
                      <span className='g_small'>Provisional</span>
                    }
                    {
                      i === scores.length - 1 && row.financialYear !== provisionalYear &&
                      <span className='g_small'>-</span>
                    }
                  </td>
                }
                {
                  (i != scores.length - 3 && i != scores.length - 2 && i != scores.length - 1) && allYrs &&
                  <td className='right g_ultra_muted'>
                    <div className='g_m_left_100'><b className='g_no_wrap'>{row.financialYear}</b></div>
                    {
                      (i !== scores.length - 2 && i !== scores.length - 1) &&
                      <span className='g_small'>Audited</span>
                    }
                  </td>
                }
              </React.Fragment>
            )
          }
          <td className='g_text_center'>
            {!showRng && <ButtonUI onClick={onShowScoreRanges} transparent={true} label='vvvvvvvv' />}
            {showRng && <ButtonUI onClick={onHideScoreRanges} transparent={true} label='^^^^^^^^' />}
          </td>
        </tr>
      </thead><tbody>
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='1' name='companyCreditRating' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='2' name='leadDirectorCreditRating' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='3' name='dscr' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='4' name='loanToValue' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='5' name='revenueToLoanRatio' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='6' name='liabilityToRevenueRatio' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='7' name='netDebtToEbitdaRatio' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='8' name='cashProfitPercent' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='9' name='receivablesToIncomeRatio' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='10' name='dso' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='11' name='chequeBounce' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='12' name='triangulationIncome' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='13' name='triangulationDebt' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='14' name='triangulationExpenses' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='15' name='triangulationCashProfit' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='16' name='noOfLitigations' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='18' name='delinquencies' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='19' name='trackRecordCompany' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='20' name='trackRecordPromoter' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='21' name='references' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='22' name='stateCount' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='23' name='poCounterParty' />
          <Row scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} id='24' name='ldPaid' />
          <TotalUI scores={scores} ranges={ranges} allYrs={allYrs} showRng={showRng} />
        </tbody></table>
    */}

    {
      ranges && scores &&
      <ScoreRanges ranges={ranges} />
    }
  </div>

const ScoreRanges = ({ ranges }) =>
  <>
    <h2 className='g_m_top_200'>Score Card Ranges</h2>
    <div className='g_flex_h score_range'>
      {
        ranges.map((scoreRange, i) =>
          <div key={i} className='g_m_left_100 g_m_top_100'>
            <b>{scoreRange.scoreName}</b><br />
            <ScoreRangeUI scoreRange={scoreRange} />
          </div>
        )
      }
    </div>
  </>

const ScoreRangeUI = ({ scoreRange }) =>
  <table border='1'><tbody>
    {
      scoreRange.rangeItemList.map((item, j) =>
        <tr key={j}>
          <td><span className='g_m_left_25 g_m_right_25'>{item.key}</span></td>
          {
            !scoreRange.scoreName.startsWith('totalScore') &&
            <td><span className='g_m_left_25 g_m_right_25'>{item.val}</span></td>
          }
          {
            /* scoreRange.scoreName.startsWith('totalScore') && */
            <td><span className='g_m_left_25 g_m_right_25'>{item.rating}</span></td>
          }
        </tr>
      )
    }
  </tbody></table>

const RowM = ({scores, ranges, id, name, allYrs, stp, itr, showRng, updClk, edit}) =>
  <Row scores={scores} ranges={ranges} showRng={showRng} id={id} updClk={updClk} edit={edit} allYrs={allYrs}
    name={`${name}${stp ? 'STP' : ''}${itr ? 'ITR' : 'MCA'}`} />

const Row = ({ scores, ranges, id, name, allYrs, showRng, updClk, edit }) =>
  <tr>
    <td>
      <span className='g_flex_h g_flex_left'>
        <span className='g_m_right_50 g_no_wrap_2'>{id}</span>
        <Desc name={name} />
      </span>
      {
        scores.map((row, i) =>
          <React.Fragment key={i}>
            {
              row[name + 'Remarks'] &&
              <span className='g_info g_small'>{row[name + 'Remarks']}</span>
            }
          </React.Fragment>
        )
      }
    </td>
    {
      scores.map((row, i) =>
        <React.Fragment key={i}>
          {
            (i == scores.length - 3 || i == scores.length - 2 || i == scores.length - 1) &&
            <td className={`center ${row[name].css}`}>
              <b>{row[name].rating}</b><br />
              <span className='g_muted'>{row[name].score}</span><br />
              <span className='g_muted g_small'>
                {
                  row[name].value === '9999999.0000' &&
                  <span className='g_xxlarge'>∞</span>
                }
                {
                  row[name].value !== '9999999.0000' && <>{row[name].value}</>
                }
              </span><br />
            </td>
          }
          {
            (i != scores.length - 3 && i != scores.length - 2 && i != scores.length - 1) && allYrs &&
            <td className={`center g_ultra_muted`}>
              {row[name].rating}<br />
              <span>{row[name].score}</span><br />
              <span className='g_small'>
                {
                  row[name].value === '9999999.0000' &&
                  <span className='g_xxlarge'>∞</span>
                }
                {
                  row[name].value !== '9999999.0000' && <>{row[name].value}</>
                }
              </span><br />
            </td>
          }
        </React.Fragment>
      )
    }
    <td>
      {
        updClk && edit &&
        <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={updClk}
          data-object-code='score_card' data-object-id={name}></span>
      }
    </td>
    {
      showRng && ranges.filter(scoreRange => scoreRange.scoreName === name).map((scoreRange, i) =>
        <td key={i}>
          <ScoreRangeUI scoreRange={scoreRange} />
        </td>
      )
    }
  </tr>

const TotalUI = ({ scores, ranges, allYrs, stp, itr, showRng, updClk, edit }) =>
  <>
    <tr>
      <td className='total'>
        Total Score
      </td>
      {
        scores.map((row, i) =>
          <React.Fragment key={i}>
            {
              (i == scores.length - 3 || i == scores.length - 2 || i == scores.length - 1) &&
              <td className={`center total ${row['css']}`}>
                {row['rating' + (stp ? 'STP' : '') + (itr ? 'ITR' : 'MCA')]}<br />
                <span className='g_muted'>{row['totalScore' + (stp ? 'STP' : '') + (itr ? 'ITR' : 'MCA')]}</span>
              </td>
            }
            {
              (i != scores.length - 3 && i != scores.length - 2 && i != scores.length - 1) && allYrs &&
              <td className={`center total g_ultra_muted`}>
                {row['rating' + (stp ? 'STP' : '') + (itr ? 'ITR' : 'MCA')]}<br />
                <span>{row['totalScore' + (stp ? 'STP' : '') + (itr ? 'ITR' : 'MCA')]}</span>
              </td>
            }
          </React.Fragment>
        )
      }
      {
        edit &&
        <td>
          <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={updClk}
            data-object-code='score_card' data-object-id='totalScore'></span>
        </td>
      }
      {
        showRng && ranges.filter(scoreRange => scoreRange.scoreName === 'totalScore').map((scoreRange, i) =>
          <td key={i}>
            <ScoreRangeUI scoreRange={scoreRange} />
          </td>
        )
      }
    </tr>
    {
      scores.filter(row => row['totalScoreRemarks']).length > 0 &&
      <tr><td colSpan='8'>
        <span className='g_muted'>Remarks: {scores.filter(row => row['totalScoreRemarks'])[0]['totalScoreRemarks']}</span>
      </td></tr>
    }
  </>

const Desc = ({ name }) =>
  <span className='g_no_wrap'>
    {(() => {
      switch (name) {
        case 'companyCreditRatingMCA':
          return 'Company credit rating (MCA)'
        case 'companyCreditRatingITR':
          return 'Company credit rating (ITR)'
        case 'companyCreditRatingSTPMCA':
          return 'Company credit rating (STP-MCA)'
        case 'companyCreditRatingSTPITR':
          return 'Company credit rating (STP-ITR)'

        case 'leadDirectorCreditRatingMCA':
          return 'Lead director credit rating (MCA)'
        case 'leadDirectorCreditRatingITR':
          return 'Lead director credit rating (ITR)'
        case 'leadDirectorCreditRatingSTPMCA':
          return 'Lead director credit rating (STP-MCA)'
        case 'leadDirectorCreditRatingSTPITR':
          return 'Lead director credit rating (STP-ITR)'

        case 'dscrMCA':
          return 'DSCR (MCA)'
        case 'dscrITR':
          return 'DSCR (ITR)'
        case 'dscrSTPMCA':
          return 'DSCR (STP-MCA)'
        case 'dscrSTPITR':
          return 'DSCR (STP-ITR)'

        case 'loanToValueMCA':
          return 'Loan to value (MCA)'
        case 'loanToValueITR':
          return 'Loan to value (ITR)'
        case 'loanToValueSTPMCA':
          return 'Loan to value (STP-MCA)'
        case 'loanToValueSTPITR':
          return 'Loan to value (STP-ITR)'

        case 'revenueToLoanRatioMCA':
          return 'Revenue to loan (MCA)'
        case 'revenueToLoanRatioITR':
          return 'Revenue to loan (ITR)'
        case 'revenueToLoanRatioSTPMCA':
          return 'Revenue to loan (STP-MCA)'
        case 'revenueToLoanRatioSTPITR':
          return 'Revenue to loan (STP-ITR)'

        case 'liabilityToRevenueRatioMCA':
          return 'Liability to revenue (MCA)'
        case 'liabilityToRevenueRatioITR':
          return 'Liability to revenue (ITR)'
        case 'liabilityToRevenueRatioSTPMCA':
          return 'Liability to revenue (STP-MCA)'
        case 'liabilityToRevenueRatioSTPITR':
          return 'Liability to revenue (STP-ITR)'

        case 'netDebtToEbitdaRatioMCA':
          return 'Net debt to EBITDA (MCA)'
        case 'netDebtToEbitdaRatioITR':
          return 'Net debt to EBITDA (ITR)'
        case 'netDebtToEbitdaRatioSTPMCA':
          return 'Net debt to EBITDA (STP-MCA)'
        case 'netDebtToEbitdaRatioSTPITR':
          return 'Net debt to EBITDA (STP-ITR)'

        case 'cashProfitPercentMCA':
          return 'Cash profit percent (MCA)'
        case 'cashProfitPercentITR':
          return 'Cash profit percent (ITR)'
        case 'cashProfitPercentSTPMCA':
          return 'Cash profit percent (STP-MCA)'
        case 'cashProfitPercentSTPITR':
          return 'Cash profit percent (STP-ITR)'

        case 'receivablesToIncomeRatioMCA':
          return 'Receivables to income (MCA)'
        case 'receivablesToIncomeRatioITR':
          return 'Receivables to income (ITR)'
        case 'receivablesToIncomeRatioSTPMCA':
          return 'Receivables to income (STP-MCA)'
        case 'receivablesToIncomeRatioSTPITR':
          return 'Receivables to income (STP-ITR)'

        case 'dsoMCA':
          return 'DSO (MCA)'
        case 'dsoITR':
          return 'DSO (ITR)'
        case 'dsoSTPMCA':
          return 'DSO (STP-MCA)'
        case 'dsoSTPITR':
          return 'DSO (STP-ITR)'

        case 'chequeBounceMCA':
          return 'Cheque bounce (MCA)'
        case 'chequeBounceITR':
          return 'Cheque bounce (ITR)'
        case 'chequeBounceSTPMCA':
          return 'Cheque bounce (STP-MCA)'
        case 'chequeBounceSTPITR':
          return 'Cheque bounce (STP-ITR)'

        case 'triangulationIncomeMCA':
          return 'Triangulation income (MCA)'
        case 'triangulationIncomeITR':
          return 'Triangulation income (ITR)'
        case 'triangulationIncomeSTPMCA':
          return 'Triangulation income (STP-MCA)'
        case 'triangulationIncomeSTPITR':
          return 'Triangulation income (STP-ITR)'

        case 'triangulationDebtMCA':
          return 'Triangulation debt (MCA)'
        case 'triangulationDebtITR':
          return 'Triangulation debt (ITR)'
        case 'triangulationDebtSTPMCA':
          return 'Triangulation debt (STP-MCA)'
        case 'triangulationDebtSTPITR':
          return 'Triangulation debt (STP-ITR)'

        case 'triangulationExpensesMCA':
          return 'Triangulation expenses (MCA)'
        case 'triangulationExpensesITR':
          return 'Triangulation expenses (ITR)'
        case 'triangulationExpensesSTPMCA':
          return 'Triangulation expenses (STP-MCA)'
        case 'triangulationExpensesSTPITR':
          return 'Triangulation expenses (STP-ITR)'

        case 'triangulationCashProfitMCA':
          return 'Triangulation cash profit (MCA)'
        case 'triangulationCashProfitITR':
          return 'Triangulation cash profit (ITR)'
        case 'triangulationCashProfitSTPMCA':
          return 'Triangulation cash profit (STP-MCA)'
        case 'triangulationCashProfitSTPITR':
          return 'Triangulation cash profit (STP-ITR)'

        case 'noOfLitigationsMCA':
          return 'No of litigations (MCA)'
        case 'noOfLitigationsITR':
          return 'No of litigations (ITR)'
        case 'noOfLitigationsSTPMCA':
          return 'No of litigations (STP-MCA)'
        case 'noOfLitigationsSTPITR':
          return 'No of litigations (STP-ITR)'

        case 'delinquenciesMCA':
          return 'Delinquencies (MCA)'
        case 'delinquenciesITR':
          return 'Delinquencies (ITR)'
        case 'delinquenciesSTPMCA':
          return 'Delinquencies (STP-MCA)'
        case 'delinquenciesSTPITR':
          return 'Delinquencies (STP-ITR)'

        case 'trackRecordCompanyMCA':
          return 'Company track record (MCA)'
        case 'trackRecordCompanyITR':
          return 'Company track record (ITR)'
        case 'trackRecordCompanySTPMCA':
          return 'Company track record (STP-MCA)'
        case 'trackRecordCompanySTPITR':
          return 'Company track record (STP-ITR)'

        case 'trackRecordPromoterMCA':
          return 'Promoter track record (MCA)'
        case 'trackRecordPromoterITR':
          return 'Promoter track record (ITR)'
        case 'trackRecordPromoterSTPMCA':
          return 'Promoter track record (STP-MCA)'
        case 'trackRecordPromoterSTPITR':
          return 'Promoter track record (STP-ITR)'

        case 'referencesMCA':
          return 'References (MCA)'
        case 'referencesITR':
          return 'References (ITR)'
        case 'referencesSTPMCA':
          return 'References (STP-MCA)'
        case 'referencesSTPITR':
          return 'References (STP-ITR)'

        case 'stateCountMCA':
          return 'State count (MCA)'
        case 'stateCountITR':
          return 'State count (ITR)'
        case 'stateCountSTPMCA':
          return 'State count (STP-MCA)'
        case 'stateCountSTPITR':
          return 'State count (STP-ITR)'

        case 'poCounterPartyMCA':
          return 'PO counter party (MCA)'
        case 'poCounterPartyITR':
          return 'PO counter party (ITR)'
        case 'poCounterPartySTPMCA':
          return 'PO counter party (STP-MCA)'
        case 'poCounterPartySTPITR':
          return 'PO counter party (STP-ITR)'

        case 'ldPaidMCA':
          return 'LD paid (MCA)'
        case 'ldPaidITR':
          return 'LD paid (ITR)'
        case 'ldPaidSTPMCA':
          return 'LD paid (STP-MCA)'
        case 'ldPaidSTPITR':
          return 'LD paid (STP-ITR)'

        default:
          return name
      }
    })()}
  </span>

const UpdateProvisionals = ({ showDetailsMode }) =>
  <div className='g_flex_h'>
    <SpinnerUI show={showDetailsMode} className='g_m_right_50' />
  </div>

export default ScoreCardUI
